import React, { Component } from 'react'
import _ from 'lodash'
import axios from 'axios'

import Filter from './Filter'
import FleetList from './FleetList'

import { backendURL } from '../../data/config.json'

class Fleet extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: 0,
    }
    this.handleChange = this.handleChange.bind(this)
  }
  componentDidMount() {
    axios
      .get(`${backendURL}/api/fleet`)
      .then(res => {
        return this.setState({
          fleet: res.data,
        })
      })
      .catch(err => {
        return this.setState({
          err: res.data,
        })
      })
  }
  static getDerivedStateFromProps(nextProps) {
    const { category } = nextProps
    if (_.isNumber(category)) {
      const newState = {
        filter: category,
      }
      return newState
    }
    return null
  }
  handleChange(event) {
    this.setState({ filter: event.target.value })
  }
  renderFilter() {
    if (this.props.displayFilter) {
      return (
        <div className="block fleet-filter">
          <Filter
            types={this.props.types}
            value={this.state.filter}
            lang={this.props.lang}
            handleChange={this.handleChange}
          />
        </div>
      )
    }
    return null
  }
  render() {
    return (
      <div className="fleet-content">
        {this.renderFilter()}
        <div className="block fleet-list">
          <div className="grid-wrapper">
            <FleetList
              fleet={this.state.fleet}
              filter={this.state.filter}
              lang={this.props.lang}
              types={this.props.types}
              features={this.props.features}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Fleet



// WEBPACK FOOTER //
// ./src/components/Fleet/index.js